import { E_ENQUIRY_REPORT } from "../enums/EnquiryEntriesReport";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import {
  EnquiryReportCreateDTO,
  EnquiryReportDTO,
} from "../types/EnquiryReport";
import { ListResponseData } from "../types/requests";

function getAllReports() {
  return request<ListResponseData<EnquiryReportDTO>>({
    method: ERequestMethods.GET,
    url: E_ENQUIRY_REPORT.MAIN,
  });
}

function createReport(data: EnquiryReportCreateDTO) {
  return request({
    method: ERequestMethods.POST,
    url: E_ENQUIRY_REPORT.MAIN,
    data,
  });
}

function updateReport(reportId: string, data: Partial<EnquiryReportCreateDTO>) {
  return request({
    method: ERequestMethods.PATCH,
    url: E_ENQUIRY_REPORT.UPDATE(reportId),
    data,
  });
}

function deleteReport(reportId: string) {
  return request({
    method: ERequestMethods.DELETE,
    url: E_ENQUIRY_REPORT.UPDATE(reportId),
  });
}

const EnquiryEntriesReportRepository = Object.freeze({
  getAllReports,
  createReport,
  deleteReport,
  updateReport,
});

export default EnquiryEntriesReportRepository;
